import { FB_EVENTS, sendFBEvent } from 'commons/fbEvents';
import { useEffect } from 'react';
import useMetaFormattedCityStateZip from '../useMetaFormattedCityStateZip';

const DEFAULT_BASIC_DETAILS = {};
const DEFAULT_VARIANT_SKU = '';

const useJbEventFBViewPDP = ({
  basicDetails = DEFAULT_BASIC_DETAILS,
  selectedOptionsVariantSku = DEFAULT_VARIANT_SKU,
}) => {
  const {
    formattedZip: zip,
    formattedCity: city,
    formattedState: state,
  } = useMetaFormattedCityStateZip();

  useEffect(() => {
    const sku = basicDetails?.sku
      ? basicDetails.sku + selectedOptionsVariantSku
      : null;

    if (basicDetails?.sku && basicDetails.name) {
      window.jbEventFBViewPDP = () => {
        sendFBEvent(FB_EVENTS.VIEW_PDP, {
          content_ids: [sku],
          content_name: basicDetails.name,
          content_type: 'product',
          zp: zip,
          ct: city,
          st: state,
        });
      };
    } else {
      window.jbEventFBViewPDP = undefined;
    }
  }, [
    basicDetails?.name,
    basicDetails?.sku,
    city,
    selectedOptionsVariantSku,
    state,
    zip,
  ]);
};

export default useJbEventFBViewPDP;
